export default "__VITE_ASSET__DIwSGNII__"